export default __webpack_public_path__ + "static/step2-0d4a19edeaaf5d09d3d0665bbbea04be.jpg";